import safeCreateAction from "../../actions/safeCreateAction";
export const addHistoryEvent = safeCreateAction("HISTORY_ADD_EVENT", (stack, event, limit) => ({
    stack,
    event,
    limit,
}));
export const setHistoryEvent = safeCreateAction("HISTORY_SET_EVENT", (stack, event) => ({ stack, event }));
export const markHistoryReverted = safeCreateAction("HISTORY_MARK_REVERTED", (stack, event) => ({ stack, event }));
export const showHistory = safeCreateAction("HISTORY_SHOW", (stack) => stack);
